
import Vue from 'vue'
import {ucFirst} from "./Support/TextHelper";

Vue.prototype.$placeholder = (subject, key = null) => {
    return Vue.prototype.$t('place_holder', {
        subject: Vue.prototype.$t(subject).toLowerCase(),
        type: key ? Vue.prototype.$t(key).toLowerCase() : ''
    });
};

Vue.prototype.$fieldTitle = (subject, title = null, titleCapitalize = false, infix = null) => {
    if (title) {
        let translation = Vue.prototype.$t('field_title', {
            subject: Vue.prototype.$t(subject),
            infix: infix ? Vue.prototype.$t(infix).toLowerCase() : '',
            title: titleCapitalize ? Vue.prototype.$t(title) : Vue.prototype.$t(title).toLowerCase()
        })
        return translation.split(' ').filter(a => a).join(' ');
    }
    return Vue.prototype.$t(subject);
};

Vue.prototype.$totalLabel = (name) => {
    return Vue.prototype.$t('total_context', {name: Vue.prototype.$t(name).toLowerCase()})
}
Vue.prototype.$rateLabel = (name) => {
    return Vue.prototype.$t('status_wise_rate', {status: Vue.prototype.$t(name)})
}
Vue.prototype.$allLabel = (name) => {
    return Vue.prototype.$t('all_feature_name', {name: Vue.prototype.$t(name)})
}
Vue.prototype.$addLabel = (name) => {
    return Vue.prototype.$t('add_feature_name', {name: Vue.prototype.$t(name)})
}
Vue.prototype.$editLabel = (name) => {
    return Vue.prototype.$t('edit_feature_name', {name: Vue.prototype.$t(name)})
}
Vue.prototype.$copyLabel = (name) => {
    return Vue.prototype.$t('copy_feature_name', {name: Vue.prototype.$t(name)})
}
Vue.prototype.$fieldLabel = (subject, key = 'name') => {
    return Vue.prototype.$t('field_label', {
        subject: Vue.prototype.$t(subject),
        key: key ? Vue.prototype.$t(key).toLowerCase() : '',
    })
}
Vue.prototype.$textAreaPlaceHolder = (name) => {
    return Vue.prototype.$t('textarea_placeholder', {
        name: Vue.prototype.$t(name).toLowerCase()
    })
}

/**
 * Get translation string based on locale
 *
 * @param {Object|string} neededObject - Object containing translations by locale or a plain string.
 * @param {string|null} locale - Preferred locale, defaults to document.lang.
 * @param {Array<string>} fallbacks - Fallback order if the main locale is not available.
 * @returns {string}
 */
Vue.prototype.$displayByLocale = (neededObject, locale = null, fallbacks = ['vi', 'ja', 'en', 'zh']) => {
    if (!neededObject || typeof neededObject !== 'object') {
        return neededObject || '';
    }

    const currentLocale = locale || document.documentElement.lang || 'ja';
    const chain = [currentLocale, ...fallbacks];

    for (const key of chain) {
        if (key && neededObject[key]) {
            return neededObject[key];
        }
    }

    return '';
};

Vue.prototype.$upperFirstLetter = (str) => {
    if (!str || typeof str !== 'string' || str.length === 0) {
        return '';
    }

    const firstLetter = str.charAt(0).toUpperCase();
    const restOfString = str.slice(1);

    return firstLetter + restOfString;
};